module.exports = __webpack_public_path__ + "static/shipmates-background-mobile-268272cc382143ff17ec079fafd07515.jpg";